export default {
    blue500: '#253778',
    blue400: '#005BA7',
    blue300: '#008BFF',
    blue200: '#74C0FF',
    blue100: '#E8F5FC',
    blue50: '#F3FAFD',
    green300: '#07775C',
    green200: '#0AA781',
    green100: '#DFF6F1',
    grey700: '#37383A',
    grey600: '#4A4A4A',
    grey500: '#737373',
    grey400: '#ADADAD',
    grey300: '#C8C7CC',
    grey200: '#E0E0E0',
    grey100: '#F2F2F2',
    orange600: '#AA3815',
    orange500: '#BF570C',
    orange400: '#D1603D',
    orange300: '#EC6E47',
    orange200: '#F16D0D',
    orange150: '#FFA557',
    orange100: '#FFE5D1',
    red300: '#AF061A',
    red200: '#F0102B',
    red100: '#FFE3E5',
    white50: '#FFFFFF',
    yellow200: '#F9A51A',
    yellow100: ' #FFD871',
    yellow50: '#FFF8DC',
    purple300: '#6A32C9',
    purple100: '#ECDCFC',
}
